module.exports = __webpack_public_path__ + "img/blender.c7a6edb9.png";